// Coordinates are percentages for object-position, not destructive source crops.
// Desktop >=1100px, tablet 768–1099px, mobile <=767px. Never overwrite originals.
const focal = (desktop, tablet, mobile, subject, treatment = {}) => ({
  focalPoints: { desktop, tablet, mobile }, subject,
  treatment: { brightness: 1, contrast: 1, saturation: 1, ...treatment },
});

export const HOME_ART_DIRECTION = {
  breakfast2: focal([50, 52], [50, 42], [52, 36], "Existing Carta hero: service gesture and table, with higher framing on mobile. Photograph and composition retained."),
  rocafortInterior: focal([51, 57], [53, 53], [49, 55], "Perspective of the counter and tables; preserve architectural verticals."),
  "ritual-video01": focal([50, 32], [49, 38], [48, 46], "Bartender and room. Portrait film is excluded from panoramic hero to protect the person."),
  "ritual-photo10": focal([49, 66], [49, 61], [48, 58], "Cup and saucer below the diffuser. Portrait-only hero; not forced into a panoramic crop."),
  "ritual-photo04": focal([49, 54], [48, 52], [48, 53], "Whole main dish and pouring hand. Native 4:5 frame; no extra warmth on food.", { brightness: 1.025, contrast: 1.01, saturation: 0.98 }),
  "ritual-video04": focal([50, 82], [49, 75], [49, 57], "Table and service, not the empty upper wall."),
  "ritual-photo09": focal([49, 63], [49, 59], [48, 58], "Burrata, plate rim and supporting hand. Portrait-only hero scene."),
  "ritual-photo03": focal([49, 45], [49, 46], [48, 46], "Face, both hands and coffee. Keep the native portrait proportions.", { brightness: 1.025, saturation: 0.98 }),
  "ritual-video05": focal([50, 57], [49, 55], [49, 54], "Breakfast cups and toasts; near-native vertical frame follows the moving camera."),
  "ritual-video02": focal([51, 51], [51, 49], [50, 50], "Both hands, milk stream and cup; avoid the previous tight 4:5 crop."),
  finca: focal([52, 66], [54, 62], [55, 60], "Green ridge and mountains, not the large empty sky.", { brightness: 1.02, contrast: 1.015 }),
  fincaCultivo: focal([44, 51], [43, 49], [42, 48], "Both hands and all coffee cherries; native 3:4 image."),
  "ritual-photo02": focal([49, 47], [48, 46], [48, 47], "Face, folded hands and cup kept together in native 4:5 portrait.", { brightness: 1.03, saturation: 0.98 }),
  lliria: focal([52, 47], [50, 46], [49, 45], "Full swing, neon and room edges; landscape frame on every breakpoint."),
};

export const homeImageKey = (media, breakpoint) => media[`${breakpoint}Image`] || media.image;

export const homeArtStyles = (media, imageKey) => {
  const art = HOME_ART_DIRECTION[imageKey];
  if (!art) return {};
  const points = { ...art.focalPoints, ...media.focalPoints };
  const position = ([x, y]) => `${x}% ${y}%`;
  const { brightness, contrast, saturation } = art.treatment;
  return {
    "--media-position": position(points.desktop),
    "--media-tablet-position": position(points.tablet),
    "--media-mobile-position": position(points.mobile),
    "--media-mobile-fit": media.fit?.mobile || "cover",
    "--media-treatment": `brightness(${brightness}) contrast(${contrast}) saturate(${saturation})`,
  };
};